import { styled } from "styled-components";

export const StyledAppsContainerSidebar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;
